<template>
    <div id="sql" class="mt">
        <a-row class="mt">
            <a-col>
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('generic.Add') }}</span>
                    </template>
                    <img class="sbxs" src="../../../../assets/img/ss-add.png" width="22" height="22" @click="addCondition">
                </a-tooltip>
                <a-popconfirm
                        :title="$t('generic.AreyoudeleTask')"
                        @confirm="delCondition"
                        :okText="$t('generic.Yes')"
                        :cancelText="$t('generic.No')">
                    <a-tooltip placement="topLeft" class="ml4">
                        <template slot="title">
                            <span>{{ $t('generic.Delete') }}</span>
                        </template>
                        <img class="sbxs" src="../../../../assets/img/ss-delete.png" width="22" height="22">
                    </a-tooltip>
                </a-popconfirm>
            </a-col>
            <a-col class="mt">
                <vxe-table
                        border
                        resizable
                        highlight-hover-row
                        size="mini"
                        ref="conditionRefs"
                        @cell-dblclick="cellDBLClickEvent"
                        :data="tableData">
                    <template v-slot:empty>
                        <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="columnName" title="Column Name" minWidth="150"></vxe-table-column>
                    <!--<vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dsName" title="Datasource"  minWidth="150"></vxe-table-column>-->
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="condition" title="Condition"  minWidth="150"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="value" title="Value"  minWidth="150"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="dataType" title="Data Type"  minWidth="150"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="codeMaster" title="Code Master"  minWidth="150" :visible="false"></vxe-table-column>
                    <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="searchable" title="Search"  minWidth="150">
                        <template v-slot="{ row }">
                            {{ row.searchable == "1" ? true : false }}
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </a-col>
        </a-row>
        <a-modal
                title="Add Condition"
                :visible="addConditionVis"
                width="45%"
                @cancel="() => (addConditionVis = !addConditionVis)"
        >
            <template slot="footer">
                <a-button type="primary" size="small" @click="addSaveCondition">Save</a-button>
            </template>
            <a-form :form="addConditionForm">
                <a-form-item label="Column Name" v-bind="formItemLayout">
                    <a-input
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            style="width: 100%;"
                            v-decorator="['columnName',{initialValue: editConditionVal.columnName}]"
                    />
                </a-form-item>
                <a-form-item label="Condition" v-bind="formItemLayout">
                    <a-select
                            allowClear
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            v-decorator="[ 'condition',{initialValue: editConditionVal.condition}]"
                    >
                        <a-select-option v-for="item in conditionSelect" :value="item.dataValue">{{item.dataValue}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Value" v-bind="formItemLayout">
                    <a-input
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            style="width: 100%;"
                            v-decorator="['value',{initialValue: editConditionVal.value}]"
                    />
                </a-form-item>
                <a-form-item label="Data Type" v-bind="formItemLayout">
                    <a-select
                            :placeholder="$t('publicLang.PleaseSelect')"
                            style="width: 100%"
                            size="small"
                            v-decorator="[ 'dataType',{initialValue: editConditionVal.dataType}]"
                            @change="dataTypeChange"
                    >
                        <a-select-option v-for="item in dataTypeSelect" :value="item">{{item}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="Code Master" v-bind="formItemLayout" v-if="editConditionVal.dataType == 'Dropdown' || isDropdown">
                    <a-input
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            style="width: 100%;"
                            v-decorator="['codeMaster',{initialValue: editConditionVal.codeMaster}]"
                    />
                </a-form-item>
                <a-form-item label="Search" v-bind="formItemLayout">
                    <a-switch  size="small" v-decorator="['searchable', {initialValue: editConditionVal.searchable == '1' ? true : false ,valuePropName: 'checked' }]"/>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../../api/ajax'
    import api from '../../../../api/url'
    export default{
        data(){
            return{
                tableData:[],
                conditionSelect:[],
                dataTypeSelect:[],
                addConditionForm: this.$form.createForm(this),
                formItemLayout: {
                    labelCol: {
                        xs: { span: 24 },
                        sm: { span: 8 }
                    },
                    wrapperCol: {
                        xs: { span: 24 },
                        sm: { span: 16 }
                    }
                },
                editConditionVal:{},
                addConditionVis: false,
                isDropdown: false
            }
        },
        props:{
            dataSourceRow: {
                type: Object,
                default: function() {
                    return {};
                }
            }
        },
        watch:{
            dataSourceRow(v){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods:{
            init(){
                ajax.get(api.REPORTGENERICCONFIGCONTION,{uid:this.dataSourceRow.uid}).then(res=>{
                    this.tableData = res.data
                })
            },
            addCondition(){
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.conditionSelect = res.data.condition;
                    this.dataTypeSelect = ['TEXT', 'Date', 'Datetime(00:00:00)', 'Datetime(23:59:59)', 'Dropdown'];
                });
                this.isDropdown = false
                this.addConditionVis = true
                this.addConditionForm.resetFields();
            },
            // 判断是否为Dropdown决定是否显示code_master输入框
            dataTypeChange(val){
                if(val == 'Dropdown'){
                    this.isDropdown = true
                }else{
                    this.isDropdown = false
                }
            },
            addSaveCondition(){
                this.addConditionForm.validateFields((error, values)=>{
                    let params = values
                    params.rtSqlUid = this.dataSourceRow.uid
                    params.searchable = params.searchable ? "1" : "0"
                    if(this.editConditionVal.uid){
                        params.uid = this.editConditionVal.uid
                    }
                    ajax.post(api.REPORTGENERICCONFIGCONTION,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.init()
                            this.addConditionVis = false
                            this.editConditionVal = {}
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                })
            },
            delCondition(){
                let arr = this.$refs.conditionRefs.getCheckboxRecords()
                if(arr.length > 0){
                    let params = {uids: []}
                    for(let i in arr){params.uids.push(arr[i].uid)}
                    ajax.post(api.REPORTGENERICDELCONFIGCONDITION,params).then(res=>{
                        if(res.code == 200){
                            this.init()
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'))
                }
            },
//            编辑
            cellDBLClickEvent({row}){
                this.editConditionVal = row
                this.addCondition()
            }
        }
    }
</script>